import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import {
  HowItWorksBuilderEvent,
  HowItWorksSellerEvent,
  HowItWorksBuyerEvent,
} from '@/constants/AnalyticEvents';

export const PageTypeName = {
  Builder: 'builder',
  Seller: 'seller',
  Buyer: 'buyer',
};

export const HeroSectionEvent = {
  [PageTypeName.Builder]: HowItWorksBuilderEvent.HeroClick,
  [PageTypeName.Seller]: HowItWorksSellerEvent.HeroClick,
  [PageTypeName.Buyer]: HowItWorksBuyerEvent.HeroClick,
};

export const HeroColorScheme = {
  [PageTypeName.Builder]: StyleColorSchemeType.Danger,
  [PageTypeName.Seller]: StyleColorSchemeType.Primary,
  [PageTypeName.Buyer]: StyleColorSchemeType.Success,
};
